import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#00B4D8]/20 py-10 px-4" data-id="element-177">
      <div className="max-w-3xl mx-auto text-center" data-id="element-178">
        <div className="text-[#00B4D8] text-2xl font-black tracking-widest mb-4" data-id="element-179">
          🎾 PROFEPACK™
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-180">
          El sistema de clases N°1 para profesores de pádel en Argentina.
        </p>
        <p className="text-gray-400 text-sm italic mb-6" data-id="element-181">
          Porque enseñar pádel no debería costarte todas las noches de la
          semana.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-182">
          <span data-id="element-183">📧 soporteprofepack@gmail.com</span>
          <span className="hidden sm:inline" data-id="element-184">•</span>
          <span data-id="element-185">📲 @profepack</span>
          <span className="hidden sm:inline" data-id="element-186">•</span>
          <span data-id="element-187">🌐 www.profepack.com</span>
        </div>

        <div className="h-px bg-[#00B4D8]/20 mb-6" data-id="element-188" />
        <p className="text-gray-400 text-xs mb-2" data-id="element-189">
          © ProfePack™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs mb-6" data-id="element-190">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}